
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/composer-root",
      function () {
        return require("private-next-pages/x/api/chat/composer-root.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/composer-root"])
      });
    }
  